import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LocalizedDatePipe, HCurrencyPipe, PaymentTypePipe } from "@dert-pipes";
import { LocalizedDateTimePipe } from "./pipes/dateTime.pipe";
import { OrderByPipe } from "./pipes/order-by.pipe";
import { CurrencyMapPipe } from "./pipes/currency-map.pipe";
import { HasRoleDirective } from "./directives/has-role.directive";
import { SelectAllOnFocusDirective } from "./directives/select-all-on-focus.directive";

@NgModule({
  declarations: [
    HCurrencyPipe,
    LocalizedDatePipe,
    LocalizedDateTimePipe,
    PaymentTypePipe,
    OrderByPipe,
    HasRoleDirective,
    SelectAllOnFocusDirective,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    CurrencyMapPipe
  ],
  exports: [
    HCurrencyPipe,
    CurrencyMapPipe,
    LocalizedDatePipe,
    LocalizedDateTimePipe,
    TranslateModule,
    PaymentTypePipe,
    HasRoleDirective,
    OrderByPipe,
    SelectAllOnFocusDirective,
  ]
})
export class SharedModule {}
